import { Icon, type IconProps } from "./icon";

/** Automations: steps joined into a graph. */
export function AutomationsIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <circle cx="5" cy="4.75" r="1.75" />
      <circle cx="5" cy="15.25" r="1.75" />
      <circle cx="15" cy="10" r="1.75" />
      <path d="M5 6.5v7M6.6 5.6c4 .8 6.2 2 6.9 3.2M6.6 14.4c4-.8 6.2-2 6.9-3.2" />
    </Icon>
  );
}
